import { create } from 'zustand';

export const useUploadStore = create((set) => ({
  // Image
  selectedImageToSend: null,
  urlImageToSend: [],

  // Video
  selectedVideoToSend: null,
  urlVideoToSend: [],

  // Document
  selectedDocumentToSend: null,
  urlDocumentToSend: [],

  // Upload progress
  isMediaUploadLoading: false,
  mediaUploadProgress: 0,

  // Audio recording
  audioBlob: null,
  audioBlobURL: null,
  isUploadingAudioMessage: false,

  // Setters
  setSelectedImageToSend: (image) => set({ selectedImageToSend: image }),
  setUrlImageToSend: (urls) => set({ urlImageToSend: urls }),
  setSelectedVideoToSend: (video) => set({ selectedVideoToSend: video }),
  setUrlVideoToSend: (urls) => set({ urlVideoToSend: urls }),
  setSelectedDocumentToSend: (doc) => set({ selectedDocumentToSend: doc }),
  setUrlDocumentToSend: (urls) => set({ urlDocumentToSend: urls }),
  setIsMediaUploadLoading: (loading) => set({ isMediaUploadLoading: loading }),
  setMediaUploadProgress: (progress) => set({ mediaUploadProgress: progress }),
  setAudioBlob: (blob) => set({ audioBlob: blob }),
  setAudioBlobURL: (url) => set({ audioBlobURL: url }),
  setIsUploadingAudioMessage: (uploading) => set({ isUploadingAudioMessage: uploading }),

  // Actions
  cancelAudioRecording: () => set({
    audioBlob: null,
    audioBlobURL: null,
  }),

  clearAllMedia: () => set({
    selectedImageToSend: null,
    urlImageToSend: [],
    selectedVideoToSend: null,
    urlVideoToSend: [],
    selectedDocumentToSend: null,
    urlDocumentToSend: [],
    audioBlob: null,
    audioBlobURL: null,
    isMediaUploadLoading: false,
    mediaUploadProgress: 0,
  }),
}));
